import { useTranslate } from '@prenuvo/halo';

import { useStudyGuard } from '@/shared/guard';

import { usePatientPermissionsAndDetails } from '../use-header-permissions.hook';

export interface ResponsiveItem {
  hideLabel?: boolean;
  label: string;
  value: string;
}

export function useResponsiveItems(): ResponsiveItem[] {
  const {
    radiologistScan: { machineID, poetryMetadata },
  } = useStudyGuard();
  const { identifier, skuPackage } = usePatientPermissionsAndDetails();

  const translate = useTranslate();

  if (poetryMetadata) {
    return [
      { label: translate('FCT.REPORTING.HEADER.LABELS.IDENTIFIER') as string, value: identifier },
      {
        label: translate('FCT.REPORTING.HEADER.LABELS.SCANNER') as string,
        value: machineID || (translate('FCT.REPORTING.HEADER.UNKNOWN.SCANNER') as string),
      },
    ];
  }

  return [
    { label: translate('FCT.REPORTING.HEADER.LABELS.IDENTIFIER') as string, value: identifier },
    {
      label: translate('FCT.REPORTING.HEADER.LABELS.PACKAGE') as string,
      value: skuPackage,
    },
    {
      label: translate('FCT.REPORTING.HEADER.LABELS.SCANNER') as string,
      value: machineID || (translate('FCT.REPORTING.HEADER.UNKNOWN.SCANNER') as string),
    },
  ];
}
